import { GetIsNewComplaintViewResp } from 'types/api/response/get-is-new-complaint-view-resp'

import { api } from './api'

export const getIsNewComplaintViewEnabled = (faqEntryId: number) =>
  api.get<GetIsNewComplaintViewResp>(`faq_entries/${faqEntryId}/complaint_view`)
